<template>
  <div>
    <h5 class="mb-1 mt-3">{{ $t("disposal-method.periodic") }} <span class="text-muted">({{ $t("common.month") }})</span></h5>
    <input v-model="disposalPeriod" class="form-control" type="number" min="0" max="360" />
    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
/** TKP-27 / 6.1 — düğümün saklama süresi (`PUT /process-data/disposal-period`); K2-a: kaynaklar birleşirken en uzun kazanır. */
export default {
  // TKP-188: `prepareMode` — değer yazılmaz, `onPrepared(ay)` ile çağırana verilir (dört seviyeli panel seçili her veriye yazar)
  props: ["id", "node", "prepareMode"],
  data() {
    return { disposalPeriod: 0 };
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationProcessData/isUpdating"];
    },
  },
  watch: {
    node: {
      immediate: true,
      deep: true,
      handler(v) {
        this.disposalPeriod = v?.feature?.disposalPeriod ?? 0;
      },
    },
  },
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) return;
      try {
        if (this.prepareMode) {
          this.$emit("onPrepared", Number(this.disposalPeriod));
          this.$root.$emit("bv::toggle::collapse", this.id);
          return;
        }
        await this.$store.dispatch("organizationProcessData/updateDisposalPeriod", { _id: this.node._id, disposalPeriod: this.disposalPeriod });
        this.$emit("onSave", Number(this.disposalPeriod));
        this.$root.$emit("bv::toggle::collapse", this.id);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
